import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Switch from 'flarum/common/components/Switch';

/*
 * Préférence d'ouverture des liens contenus dans les messages.
 *
 * false -> même onglet (_self)
 * true  -> nouvel onglet (_blank)
 *
 * La navigation propre à Flarum n'est volontairement pas concernée.
 */

function userWantsNewTab() {
  const user = app.session && app.session.user;
  return !!(user && user.preferences && user.preferences() && user.preferences().valOpenLinksNewTab);
}
function isContentLink(link) {
  if (!link || !link.closest) return false;

  /* Liens insérés dans le contenu des messages uniquement. */
  if (!link.closest('.Post-body')) return false;
  const href = link.getAttribute('href');
  if (!href) return false;

  /* Ne pas modifier les ancres, téléchargements ou protocoles spéciaux. */
  if (link.hasAttribute('download')) return false;
  if (href.charAt(0) === '#') return false;
  if (/^(?:javascript:|data:|mailto:|tel:)/i.test(href)) {
    return false;
  }
  return true;
}
function applyTarget(link) {
  if (!isContentLink(link)) return;
  if (userWantsNewTab()) {
    link.setAttribute('target', '_blank');
    const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    rel.add('noopener');
    rel.add('noreferrer');
    link.setAttribute('rel', Array.from(rel).join(' '));
  } else {
    link.setAttribute('target', '_self');
  }
}
app.initializers.add('val-ui-link-target-preference', () => {
  /*
   * Paramètres utilisateur.
   */
  extend('flarum/forum/components/SettingsPage', 'deviceItems', function (items) {
    if (!this.user) return;
    items.add('valOpenLinksNewTab', m(Switch, {
      state: !!this.user.preferences()?.valOpenLinksNewTab,
      loading: !!this.valOpenLinksNewTabLoading,
      onchange: value => {
        this.valOpenLinksNewTabLoading = true;
        this.user.savePreferences({
          valOpenLinksNewTab: value
        }).then(() => {
          this.valOpenLinksNewTabLoading = false;
          m.redraw();
        }).catch(() => {
          this.valOpenLinksNewTabLoading = false;
          m.redraw();
        });
      }
    }, app.translator.trans('val-ui.forum.settings.open_links_new_tab_label'), m("span", {
      className: "helpText"
    }, app.translator.trans('val-ui.forum.settings.open_links_new_tab_help'))), 90);
  });

  /*
   * Délégation globale :
   * on fixe target juste avant que le navigateur traite le clic.
   *
   * Cela fonctionne aussi pour les messages chargés ensuite par Mithril,
   * sans MutationObserver.
   */
  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!target || !target.closest) return;
    const link = target.closest('a[href]');
    applyTarget(link);
  }, true);
});